// extracted by mini-css-extract-plugin
module.exports = {"container":"G6IuYUExzBs-","text":"ICLKl_joId2S","footer":"_3lyhIH2ZrM0Q","button":"_24gOx11n37V1","button_cancel":"_1rxB8472iCEp"};